import { render, staticRenderFns } from "./jenis_bahan_pangan.vue?vue&type=template&id=3f096815&"
import script from "./jenis_bahan_pangan.vue?vue&type=script&lang=js&"
export * from "./jenis_bahan_pangan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports